import './ReportList.scss';

import { bem } from 'mission-control-common-components';
import { useState } from 'react';

import { OrderOption } from '../../../../../apis/graphql';
import ErrorMessage from '../../../../../common/ErrorMessage';
import Loader from '../../../../../common/Loader';
import { useInfiniteScroll } from '../../../../../hooks/useInfiniteScroll';
import { REPORT_LIST_CONFIRM_TEXT, REPORT_LIST_PAGE_LABEL, REPORT_LIST_PAGE_TITLE } from '../constants';
import CustomPacingScheduleHeader from '../CustomPacingScheduleHeader';
import { useCustomPacingScheduleContext } from '../CustomPacingScheduleProvider/CustomPacingScheduleProvider';
import DefaultContentWrapper from '../DefaultContentWrapper';
import { useReportList } from './hooks/useReportList';
import ReportListRow from './ReportListRow';
import ReportListTableHeader from './ReportListTableHeader';

const [block, element] = bem('custom-pacing-report-list');

const LoaderRow = (): React.JSX.Element => (
  <tr className={element('util-row')}>
    <td colSpan={4}>
      <Loader className={element('loader')} />
    </td>
  </tr>
);

const ReportList = (): React.JSX.Element => {
  const [sortOrder, setSortOrder] = useState<OrderOption>(OrderOption.Desc);

  const { onClose } = useCustomPacingScheduleContext();
  const { loading, hasMore, reportList, fetchMore, errorMessage } = useReportList(sortOrder);
  const { triggerRef } = useInfiniteScroll<HTMLTableRowElement>({ hasMore, loading, fetchMore });

  const onToggleSortOrder = (): void => {
    setSortOrder((currentOrder) => (currentOrder === OrderOption.Asc ? OrderOption.Desc : OrderOption.Asc));
  };

  return (
    <>
      <CustomPacingScheduleHeader customConfirmText={REPORT_LIST_CONFIRM_TEXT} onConfirm={onClose} />
      <DefaultContentWrapper>
        <div className={block()}>
          <h2>{REPORT_LIST_PAGE_TITLE}</h2>
          <p>{REPORT_LIST_PAGE_LABEL}</p>
          <div className={element('table-container')}>
            <table>
              <ReportListTableHeader sortOrder={sortOrder} onToggleSortOrder={onToggleSortOrder} />
              <tbody>
                {reportList.map((report) => (
                  <ReportListRow key={report.id} report={report} />
                ))}
                {loading && <LoaderRow />}
                {!loading && !errorMessage && <tr data-testid={'load-more-row-trigger'} ref={triggerRef}></tr>}
                {errorMessage && <ErrorMessage message={errorMessage} />}
              </tbody>
            </table>
          </div>
        </div>
      </DefaultContentWrapper>
    </>
  );
};

export default ReportList;
